export const Images = {
  logo: require("./Logo_Newin-Cortada.png"),
};
